import React, { useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { HeaderPage, TablesListAdmin } from "../../components/Admin";
import { useTable } from "../../hooks";

// "Pedidos": el salón (pantalla por defecto del Admin). Venta rápida,
// WhatsApp y delivery tienen su propia pantalla (ExternalOrdersAdmin).
export function OrdersAdmin(props) {
  const { mode = "salon" } = props;
  const { loading, tables, getTables } = useTable();

  useEffect(() => {
    getTables();
  }, []);

  return (
    <>
      <HeaderPage title={mode === "external" ? "Venta rápida y delivery" : "Pedidos"} />
      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <TablesListAdmin tables={tables} mode={mode} />
      )}
    </>
  );
}

export function ExternalOrdersAdmin() {
  return <OrdersAdmin mode="external" />;
}
